"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarImageViewStore = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("Common/AssetLibrary/ImageLibrary/Types");
var Types_2 = require("Common/ImageService/Types");
var Types_3 = require("@CommonFrontendBackend/Folders/Types");
var Types_4 = require("Common/AssetLibrary/Types");
var SidebarImageViewStore = (function () {
    function SidebarImageViewStore(imageLibraryDataStore, trackSearchPerformed, imageFoldersViewStore, isUsingImageFolders) {
        var _this = this;
        this.imageLibraryDataStore = imageLibraryDataStore;
        this.trackSearchPerformed = trackSearchPerformed;
        this.imageFoldersViewStore = imageFoldersViewStore;
        this.isUsingImageFolders = isUsingImageFolders;
        this._searchString = "";
        this._isNextPageLoading = false;
        this._isShowingQwilrStockImages = false;
        this._errorOccurredWhileFetchingContent = false;
        this._isEnteringSearchTerm = false;
        this.uploadIdsToRender = new Set();
        this.handleSearchStringChange = function (value) {
            _this.resetView();
            _this._searchString = value;
            _this._currentUnsplashCollection = undefined;
            _this.imageLibraryDataStore.emptyAssetList();
            if (value) {
                _this._isEnteringSearchTerm = true;
                _this.debounceSearch();
            }
        };
        this.selectFolder = function (folder) {
            _this.resetView();
            _this.imageFoldersViewStore.folderSelectionStore.setSelectedFolder(folder);
            _this._currentUnsplashCollection = undefined;
            _this.imageLibraryDataStore.selectFolder(_this.currentFolder);
        };
        this.debounceSearch = (0, lodash_1.debounce)(function () {
            (0, mobx_1.runInAction)(function () {
                _this._isEnteringSearchTerm = false;
                _this.trackSearchPerformed();
            });
        }, 500);
        this.showQwilrStockImages = function () {
            _this.resetView();
            _this._isShowingQwilrStockImages = true;
            _this._currentUnsplashCollection = undefined;
        };
    }
    Object.defineProperty(SidebarImageViewStore.prototype, "searchString", {
        get: function () {
            return this._searchString;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarImageViewStore.prototype, "currentFolder", {
        get: function () {
            return this.imageFoldersViewStore.folderSelectionStore.selectedFolder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarImageViewStore.prototype, "currentFolderTitle", {
        get: function () {
            if (this.currentFolder === Types_1.ImageLibrarySystemFolder.Unsplash && this.currentUnsplashCollectionTitle) {
                return (0, lodash_1.capitalize)(this.currentUnsplashCollectionTitle);
            }
            else if (Types_4.FolderNamesMapping.hasOwnProperty(this.currentFolder)) {
                return Types_4.FolderNamesMapping[this.currentFolder];
            }
            else if (this.isUsingImageFolders) {
                return this.imageFoldersViewStore.getFolderName(this.currentFolder) || "";
            }
            else {
                return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarImageViewStore.prototype, "currentFolderIcon", {
        get: function () {
            return (0, Types_4.FolderIconsMapping)(icons_1.IconSize.Medium)[this.currentFolder] || react_1.default.createElement(icons_1.Folder, { size: icons_1.IconSize.Medium });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarImageViewStore.prototype, "currentUnsplashCollectionId", {
        get: function () {
            var _a;
            return (_a = this._currentUnsplashCollection) === null || _a === void 0 ? void 0 : _a.collectionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarImageViewStore.prototype, "currentUnsplashCollectionTitle", {
        get: function () {
            var _a;
            return (_a = this._currentUnsplashCollection) === null || _a === void 0 ? void 0 : _a.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarImageViewStore.prototype, "isNextPageLoading", {
        get: function () {
            return this._isNextPageLoading;
        },
        enumerable: false,
        configurable: true
    });
    SidebarImageViewStore.prototype.loadNextPage = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isNextPageLoading) {
                            return [2];
                        }
                        this._isNextPageLoading = true;
                        return [4, this.fetchContent()];
                    case 1:
                        _a.sent();
                        this._isNextPageLoading = false;
                        return [2];
                }
            });
        });
    };
    SidebarImageViewStore.prototype.selectUnsplashCollection = function (collection) {
        this.resetView();
        this._currentUnsplashCollection = collection;
    };
    SidebarImageViewStore.prototype.deselectUnsplashCollection = function () {
        this.resetView();
        this._currentUnsplashCollection = undefined;
    };
    SidebarImageViewStore.prototype.addUploadId = function (uploadId) {
        this.uploadIdsToRender.add(uploadId);
    };
    SidebarImageViewStore.prototype.shouldRenderUploadId = function (uploadId) {
        return this.uploadIdsToRender.has(uploadId);
    };
    SidebarImageViewStore.prototype.clearUploadIds = function () {
        this.uploadIdsToRender.clear();
    };
    SidebarImageViewStore.prototype.clear = function () {
        this.resetView();
    };
    SidebarImageViewStore.prototype.fetchContent = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 10, , 11]);
                        if (!!!this.searchString) return [3, 2];
                        return [4, this.imageLibraryDataStore.searchAssets(this.searchString)];
                    case 1:
                        _b.sent();
                        return [2];
                    case 2:
                        if (!(this.currentFolder === Types_1.ImageLibrarySystemFolder.Unsplash)) return [3, 8];
                        if (!this.isShowingQwilrStockImages) return [3, 4];
                        return [4, this.imageLibraryDataStore.fetchQwilrStockImages()];
                    case 3:
                        _b.sent();
                        return [2];
                    case 4:
                        if (!this.currentUnsplashCollectionId) return [3, 6];
                        return [4, this.imageLibraryDataStore.fetchCollectionImages(this.currentUnsplashCollectionId)];
                    case 5:
                        _b.sent();
                        return [2];
                    case 6: return [4, this.imageLibraryDataStore.fetchCollections()];
                    case 7:
                        _b.sent();
                        return [2];
                    case 8: return [4, this.imageLibraryDataStore.fetchAssets()];
                    case 9:
                        _b.sent();
                        return [3, 11];
                    case 10:
                        _a = _b.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this._errorOccurredWhileFetchingContent = true;
                        });
                        return [3, 11];
                    case 11: return [2];
                }
            });
        });
    };
    SidebarImageViewStore.prototype.resetView = function () {
        this.imageLibraryDataStore.emptyAssetList();
        this.imageLibraryDataStore.emptyCollectionList();
        this._searchString = "";
        this._errorOccurredWhileFetchingContent = false;
    };
    Object.defineProperty(SidebarImageViewStore.prototype, "isShowingQwilrStockImages", {
        get: function () {
            return this._isShowingQwilrStockImages;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarImageViewStore.prototype, "errorOccurredWhileFetchingContent", {
        get: function () {
            return this._errorOccurredWhileFetchingContent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarImageViewStore.prototype, "isEnteringSearchTerm", {
        get: function () {
            return this._isEnteringSearchTerm;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e, _f;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof Types_2.IUnsplashServiceCollection !== "undefined" && Types_2.IUnsplashServiceCollection) === "function" ? _a : Object)
    ], SidebarImageViewStore.prototype, "_currentUnsplashCollection", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "_searchString", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "_isNextPageLoading", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "_isShowingQwilrStockImages", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "_errorOccurredWhileFetchingContent", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "_isEnteringSearchTerm", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "uploadIdsToRender", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "searchString", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof Types_3.ImageLibraryFolderId !== "undefined" && Types_3.ImageLibraryFolderId) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "currentFolder", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "currentFolderTitle", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof JSX !== "undefined" && JSX.Element) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "currentFolderIcon", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "currentUnsplashCollectionId", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "currentUnsplashCollectionTitle", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "isNextPageLoading", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "handleSearchStringChange", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], SidebarImageViewStore.prototype, "loadNextPage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "selectFolder", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Types_2.IUnsplashServiceCollection !== "undefined" && Types_2.IUnsplashServiceCollection) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], SidebarImageViewStore.prototype, "selectUnsplashCollection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SidebarImageViewStore.prototype, "deselectUnsplashCollection", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SidebarImageViewStore.prototype, "addUploadId", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SidebarImageViewStore.prototype, "clearUploadIds", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SidebarImageViewStore.prototype, "clear", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], SidebarImageViewStore.prototype, "fetchContent", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SidebarImageViewStore.prototype, "resetView", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SidebarImageViewStore.prototype, "showQwilrStockImages", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "isShowingQwilrStockImages", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "errorOccurredWhileFetchingContent", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SidebarImageViewStore.prototype, "isEnteringSearchTerm", null);
    return SidebarImageViewStore;
}());
exports.SidebarImageViewStore = SidebarImageViewStore;
